import type { ReactNode } from 'react';
import React from 'react';
import * as styles from '../css/text-with-image-section-scenarios.css';
import HorizontalContentPadding from '../containers/HorizontalContentPadding';

interface Props {
    text: ReactNode;
    image: ReactNode;
}

const TextWithImageSectionScenarios = ({ text, image }: Props) => (
    <div className={styles.root}>
        <HorizontalContentPadding className={styles.text}>
            {text}
        </HorizontalContentPadding>
        <HorizontalContentPadding className={styles.image}>
            {image}
        </HorizontalContentPadding>
    </div>
);

export default TextWithImageSectionScenarios;
